import { render, staticRenderFns } from "./realNameSaveInfo.vue?vue&type=template&id=bb7258c6&scoped=true"
import script from "./realNameSaveInfo.vue?vue&type=script&lang=js"
export * from "./realNameSaveInfo.vue?vue&type=script&lang=js"
import style0 from "./realNameSaveInfo.vue?vue&type=style&index=0&id=bb7258c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___2141a494b913d03a9170cbed536032b7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7258c6",
  null
  
)

export default component.exports